import { AccessTime } from '@mui/icons-material';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';

type Props = {
  pendingText: string;
  isActionDisabled: boolean;
  isSaving?: boolean;
  onDiscard: () => void;
  onSave: () => void;
};

export const LabelsFooter = ({
  pendingText,
  isActionDisabled,
  isSaving,
  onDiscard,
  onSave
}: Props) => (
  <Stack direction="row" alignItems="center" gap={0.5}>
    {pendingText !== 'No pending changes' && (
      <AccessTime sx={{ fontSize: 14, color: 'warning.main' }} />
    )}
    <Typography
      fontSize={10}
      variant="caption"
      color="text.secondary"
      title={pendingText}
      lineHeight={1.25}
      sx={{ flex: 1, minWidth: 0 }}
    >
      {pendingText}
    </Typography>
    <Stack direction="row" gap={1} flexShrink={0}>
      <Button
        size="small"
        disabled={isActionDisabled}
        onClick={onDiscard}
        sx={{ whiteSpace: 'nowrap' }}
      >
        Discard
      </Button>
      <Button
        size="small"
        variant="contained"
        disabled={isActionDisabled}
        onClick={onSave}
        sx={{ whiteSpace: 'nowrap' }}
      >
        {isSaving ? (
          <CircularProgress size={14} color="inherit" />
        ) : (
          'Save changes'
        )}
      </Button>
    </Stack>
  </Stack>
);
